<template>
    <div class="p-3">
        <h3>Merge Pasien Details</h3>
        <hr />

        <div class="row">
            <div class="col-sm-3">
                <h4 class="mb-3">Data Pasien Aktif</h4>

                <div class="card">
                    <div class="card-header text-white bg-primary">
                        Data Pasien
                    </div>

                    <div class="card-body">
                        <table class="table table-striped">
                            <tbody>
                                <template
                                    v-for="(pasien, idx) in detail_pasien"
                                >
                                    <tr :key="idx" v-if="!isExcludedField(idx)">
                                        <td>{{ idx }}</td>
                                        <td>{{ pasien }}</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="col-sm-9">
                <h4 class="mb-3">Data Pasien Merge</h4>

                <div class="card">
                    <div class="card-header text-white bg-primary">
                        Merged Pasien
                    </div>

                    <div class="card-body">
                        <table class="table table-striped mt-3">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>No Rekam Medis</th>
                                    <th>Nama</th>
                                    <th>Tanggal Lahir</th>
                                    <th>NIK</th>
                                    <th>No Kartu BPJS</th>
                                    <th>Tanggal Daftar</th>
                                    <th>Cek</th>
                                </tr>
                            </thead>

                            <tbody v-if="merged_pasiens.length > 0">
                                <tr
                                    v-for="pasien in merged_pasiens"
                                    :key="pasien.Medrec"
                                >
                                    <td></td>
                                    <td>{{ pasien.Medrec }}</td>
                                    <td>{{ pasien.Firstname }}</td>
                                    <td>{{ pasien.Bod }}</td>
                                    <td>{{ pasien.NoIden }}</td>
                                    <td>{{ pasien.AskesNo }}</td>
                                    <td>{{ pasien.tgl_daftar }}</td>
                                    <td>
                                        <button
                                            class="btn btn-sm btn-success"
                                            @click="
                                                unMergePasien(pasien.Medrec)
                                            "
                                        >
                                            UnMerge
                                        </button>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody v-else>
                                <tr>
                                    <td colspan="8">Data tidak ditemukan</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="row mt-3">
                    <h4 class="mb-3">Pencarian Data</h4>

                    <div class="col-sm-2">
                        <div class="mb-3 row">
                            <label
                                for="tanggal_dari"
                                class="col-sm-4 col-form-label text-end"
                            >
                                Dari
                            </label>

                            <div class="col-sm-8">
                                <input
                                    type="date"
                                    name="tanggal_dari"
                                    id="tanggal_dari"
                                    class="form-control"
                                    v-model="filter.tanggal_dari"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-2">
                        <div class="mb-3 row">
                            <label
                                for="tanggal_sampai"
                                class="col-sm-4 col-form-label text-end"
                            >
                                Sampai
                            </label>

                            <div class="col-sm-8">
                                <input
                                    type="date"
                                    name="tanggal_sampai"
                                    id="tanggal_sampai"
                                    class="form-control"
                                    v-model="filter.tanggal_sampai"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-5">
                        <div class="mb-3 row">
                            <label
                                for="search"
                                class="col-sm-6 col-form-label text-end"
                            >
                                No. RM/Nama/NIK/No Kartu BPJS
                            </label>

                            <div class="col-sm-6">
                                <input
                                    type="text"
                                    name="search"
                                    id="search"
                                    class="form-control"
                                    v-model="filter.search"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-3">
                        <div class="mb-3">
                            <div class="col-sm-8 text-end">
                                <button
                                    class="btn btn-danger"
                                    @click="resetFilters"
                                >
                                    <i class="fa fa-refresh"></i>
                                    Reset
                                </button>

                                <button
                                    class="btn btn-primary"
                                    @click="getAllPasien"
                                >
                                    <i class="fa fa-search"></i>
                                    Cari
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header text-white bg-primary">
                        List Pasien
                    </div>

                    <div class="card-body">
                        <div id="table-pasien"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" ref="modal_merge_pasien">
            <div class="modal-dialog" style="width: 80vw; max-width: 80vw">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Merge Pasien</h5>

                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>

                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-4">
                                <div class="card">
                                    <div
                                        class="card-header text-white bg-primary"
                                    >
                                        Data Pasien Aktif
                                    </div>

                                    <div class="card-body">
                                        <table class="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Field</th>
                                                    <th>Value</th>
                                                    <th>Use</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <template
                                                    v-for="(
                                                        pasien, idx
                                                    ) in detail_pasien"
                                                >
                                                    <tr
                                                        :key="idx"
                                                        v-if="
                                                            !isExcludedField(
                                                                idx
                                                            )
                                                        "
                                                    >
                                                        <td>{{ idx }}</td>

                                                        <td>
                                                            <input
                                                                type="text"
                                                                :name="idx"
                                                                :id="`detail-${idx}`"
                                                                v-model="
                                                                    detail_pasien[
                                                                        idx
                                                                    ]
                                                                "
                                                                class="form-control"
                                                                readonly
                                                            />
                                                        </td>

                                                        <td>
                                                            <div
                                                                class="form-check"
                                                            >
                                                                <input
                                                                    type="radio"
                                                                    class="form-check-input"
                                                                    :name="`input-${idx}`"
                                                                    :id="`input-${idx}-1`"
                                                                    checked
                                                                    @click="
                                                                        setMergedData(
                                                                            idx,
                                                                            pasien
                                                                        )
                                                                    "
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-4">
                                <div class="card">
                                    <div
                                        class="card-header text-white bg-primary"
                                    >
                                        Data Pasien Merge
                                    </div>

                                    <div class="card-body">
                                        <table class="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Field</th>
                                                    <th>Value</th>
                                                    <th>Use</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <template
                                                    v-for="(
                                                        pasien, idx
                                                    ) in data_pasien_merge"
                                                >
                                                    <tr
                                                        :key="idx"
                                                        v-if="
                                                            !isExcludedField(
                                                                idx
                                                            )
                                                        "
                                                    >
                                                        <td>{{ idx }}</td>

                                                        <td>
                                                            <input
                                                                type="text"
                                                                :name="idx"
                                                                :id="`merge-${idx}`"
                                                                v-model="
                                                                    data_pasien_merge[
                                                                        idx
                                                                    ]
                                                                "
                                                                class="form-control"
                                                                readonly
                                                            />
                                                        </td>

                                                        <td>
                                                            <div
                                                                class="form-check"
                                                            >
                                                                <input
                                                                    type="radio"
                                                                    class="form-check-input"
                                                                    :name="`input-${idx}`"
                                                                    :id="`input-${idx}-2`"
                                                                    @click="
                                                                        setMergedData(
                                                                            idx,
                                                                            pasien
                                                                        )
                                                                    "
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-4">
                                <div class="card">
                                    <div
                                        class="card-header text-white bg-primary"
                                    >
                                        Data Pasien Merged
                                    </div>

                                    <div class="card-body">
                                        <table class="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th>Field</th>
                                                    <th>Value</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <template
                                                    v-for="(
                                                        pasien, idx
                                                    ) in data_merged"
                                                >
                                                    <tr
                                                        :key="idx"
                                                        v-if="
                                                            !isExcludedField(
                                                                idx
                                                            )
                                                        "
                                                    >
                                                        <td>{{ idx }}</td>

                                                        <td>
                                                            <input
                                                                type="text"
                                                                :name="idx"
                                                                :id="`merged-${idx}`"
                                                                v-model="
                                                                    data_merged[
                                                                        idx
                                                                    ]
                                                                "
                                                                class="form-control"
                                                            />
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal"
                        >
                            Batal
                        </button>

                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="goMergePasien(data_pasien_merge.Medrec)"
                        >
                            Simpan Merge Data
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from "bootstrap/dist/js/bootstrap.bundle.min.js";
import { TabulatorFull as Tabulator } from "tabulator-tables";

export default {
    data() {
        return {
            Medrec: "",
            detail_pasien: {},
            master_pasiens: [],
            merged_pasiens: [],
            filter: {
                tanggal_dari: "",
                tanggal_sampai: "",
                search: "",
                page: 1,
            },
            data_pasien_merge: {},
            data_merged: {},
            modal_merge: null,
            table: null,
        };
    },

    created() {
        this.Medrec = this.$route.params.Medrec;
    },

    mounted() {
        this.getDetailPasien();
        this.getAllPasien();
    },

    beforeUnmount() {
        if (this.table) {
            this.table.destroy();
            this.table = null;
        }
    },

    methods: {
        isExcludedField(field) {
            return ["merged_pasien", "row_num", "rownum", "ROW_NUM"].includes(
                field
            );
        },

        cleanPasienData(data) {
            const cleanData = { ...data };

            delete cleanData.merged_pasien;
            delete cleanData.row_num;
            delete cleanData.rownum;
            delete cleanData.ROW_NUM;

            return cleanData;
        },

        getDetailPasien() {
            const uri = `/api/merge-pasien/get-detail-pasien?Medrec=${this.Medrec}`;

            this.axios.get(uri).then((response) => {
                if (response.data.status === "success") {
                    const pasien = response.data.pasien ?? {};

                    this.detail_pasien = this.cleanPasienData(pasien);
                    this.merged_pasiens = pasien.merged_pasien ?? [];
                }
            });
        },

        getAllPasien() {
            const uri = `/api/merge-pasien/get-all-pasien?tanggal_dari=${this.filter.tanggal_dari}&tanggal_sampai=${this.filter.tanggal_sampai}&search=${this.filter.search}&except=${this.Medrec}`;

            const element = document.getElementById("table-pasien");

            if (this.table) {
                this.table.destroy();
                this.table = null;
            }

            this.table = new Tabulator(element, {
                layout: "fitColumns",
                pagination: true,
                paginationMode: "remote",
                paginationSize: 10,
                paginationSizeSelector: [10, 25, 50, 100],
                ajaxURL: uri,
                ajaxResponse: this.AjaxResponse,
                sortMode: "remote",
                filterMode: "remote",
                columns: [
                    {
                        title: "No Rekam Medis",
                        field: "Medrec",
                    },
                    {
                        title: "Nama",
                        field: "Firstname",
                    },
                    {
                        title: "Tanggal Lahir",
                        field: "Bod",
                    },
                    {
                        title: "NIK",
                        field: "NoIden",
                    },
                    {
                        title: "No Kartu BPJS",
                        field: "AskesNo",
                    },
                    {
                        title: "Tanggal Daftar",
                        field: "tgl_daftar",
                    },
                    {
                        title: "Action",
                        formatter: function () {
                            return '<button class="btn btn-sm btn-primary">Merge Pasien</button>';
                        },
                        cellClick: this.mergePasien,
                    },
                ],
            });
        },

        AjaxResponse(url, params, response) {
            return response.master_pasiens;
        },

        resetFilters() {
            this.filter = {
                tanggal_dari: "",
                tanggal_sampai: "",
                search: "",
                page: 1,
            };

            this.getAllPasien();
        },

        goMergePasien(merge_medrec) {
            const uri = "/api/merge-pasien/merge-pasien";

            const data_merge = {
                head_medrec: this.Medrec,
                merge_medrec: merge_medrec,
                data_merged: this.cleanPasienData(this.data_merged),
            };

            this.axios
                .post(uri, data_merge)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.modal_merge.hide();
                        this.getDetailPasien();
                        this.getAllPasien();
                    } else {
                        alert(response.data.message || "Merge pasien gagal");
                    }
                })
                .catch((error) => {
                    alert(
                        error.response?.data?.message ||
                            error.message ||
                            "Merge pasien gagal"
                    );
                });
        },

        mergePasien(e, cell) {
            const data = cell.getRow().getData();

            this.data_pasien_merge = this.cleanPasienData(data);
            this.data_merged = this.cleanPasienData(this.detail_pasien);

            const modal_merge_pasien = this.$refs.modal_merge_pasien;

            this.modal_merge = new Modal(modal_merge_pasien);
            this.modal_merge.show();
        },

        setMergedData(idx, value) {
            if (!this.isExcludedField(idx)) {
                this.data_merged[idx] = value;
            }
        },

        unMergePasien(merge_medrec) {
            const uri = "/api/merge-pasien/unmerge-pasien";

            const data_merge = {
                head_medrec: this.Medrec,
                merge_medrec: merge_medrec,
            };

            this.axios
                .post(uri, data_merge)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.getDetailPasien();
                        this.getAllPasien();
                    } else {
                        alert(response.data.message || "Unmerge pasien gagal");
                    }
                })
                .catch((error) => {
                    alert(
                        error.response?.data?.message ||
                            error.message ||
                            "Unmerge pasien gagal"
                    );
                });
        },
    },
};
</script>
